import { useEffect } from "react"
import { buildCanonical, siteMeta, type PageMeta } from "@/lib/seo"

function upsertMeta(name: string, content: string, key: "name" | "property" = "name") {
  const selector = `meta[${key}='${name}']`
  let tag = document.head.querySelector(selector) as HTMLMetaElement | null

  if (!tag) {
    tag = document.createElement("meta")
    tag.setAttribute(key, name)
    document.head.appendChild(tag)
  }

  tag.setAttribute("content", content)
}

function upsertCanonical(href: string) {
  let link = document.head.querySelector("link[rel='canonical']") as HTMLLinkElement | null

  if (!link) {
    link = document.createElement("link")
    link.setAttribute("rel", "canonical")
    document.head.appendChild(link)
  }

  link.setAttribute("href", href)
}

export function usePageMeta({ title, description, pathname }: PageMeta) {
  useEffect(() => {
    const canonical = buildCanonical(pathname)
    const image = `${siteMeta.siteUrl}${siteMeta.defaultImage}`

    document.title = title

    upsertMeta("description", description)
    upsertMeta("og:type", "website", "property")
    upsertMeta("og:site_name", siteMeta.siteName, "property")
    upsertMeta("og:title", title, "property")
    upsertMeta("og:description", description, "property")
    upsertMeta("og:url", canonical, "property")
    upsertMeta("og:image", image, "property")
    upsertMeta("twitter:card", "summary_large_image")
    upsertMeta("twitter:title", title)
    upsertMeta("twitter:description", description)
    upsertMeta("twitter:image", image)
    upsertCanonical(canonical)
  }, [description, pathname, title])
}
